import {AxiosResponse} from "axios";

import Api from "./api";
import {Campaign, CampaignInCreate, FcmTopicsResponse} from "types";

interface GetCampaignByIdResponse {
    campaign: Campaign;
}

interface GetAllCampaignsResponse {
    campaigns: Campaign[];
}

// Data structure for FCM topics


export const getCampaignById = (campaignId: number): Promise<AxiosResponse<GetCampaignByIdResponse>> => {
    return Api.get(`/admin/campaigns/${campaignId}`);
}

export const getAllCampaigns = (): Promise<AxiosResponse<GetAllCampaignsResponse>> => {
    return Api.get("/admin/campaigns/");
}

export const getAllTopics = (): Promise<AxiosResponse<FcmTopicsResponse>> => {
    return Api.get("/admin/fcm-topics/");
}

export const createCampaignNotification = (campaignInCreate: CampaignInCreate): Promise<AxiosResponse<any>> => {
    const request = {
        notification: campaignInCreate,
    };

    return Api.post("/admin/campaigns/", request);
}

export const sendTestPushNotification = (payload: any): Promise<AxiosResponse<any>> => {
    return Api.post("/admin/notifications/send-push-notification", payload);
}

export const getFcmTopicsUsersCount = (topicsNames: string[], excludedTopicsNames?: string[]): Promise<AxiosResponse<{ usersCount: number }>> => {
    const params = new URLSearchParams();
    
    topicsNames.forEach(topic => {
        params.append('topics_names', topic);
    });
    
    if (excludedTopicsNames && excludedTopicsNames.length > 0) {
        excludedTopicsNames.forEach(topic => {
            params.append('excluded_topics_names', topic);
        });
    }
    
    return Api.get(`/admin/fcm-topics/users-count?${params.toString()}`);
};

export default {
    getCampaignById,
    getAllCampaigns,
    createCampaignNotification,
    getAllTopics,
    getFcmTopicsUsersCount,
    sendTestPushNotification
};
